import React, {Component} from 'react';
import { Nav, TabPane, NavItem, Row, NavLink, TabContent, Col, Card, CardHeader, FormText, CardBody, Button, CardFooter, Modal, ModalHeader, ModalFooter, ModalBody, Input, FormGroup, Label } from 'reactstrap';
import classnames from 'classnames';
import { connect } from 'react-redux';
import $ from 'jquery';
import Widget04 from '../../Widgets/Widget04';
import { Redirect } from 'react-router-dom';
import ReactHLS from 'react-hls';


class StoryboardDetailsPage extends Component {


  constructor(props) {
    super(props);
    this.state = {
      releaseFailureOpen:false,
      msg:Object,
      navigate:false,
      path:"",
      uploadModalOpen:true,
      editShotModalOpen:false,
      activeTab:'1',
      shotActiveTab:'1',
      assetProcessingOpen:false,
      contentStatus:false,
      coverUrl:"",
      shotCoverAddress:"",
      file:Object,
      shotAssetFile:Object,
      storyboardAssetFile:Object,
      selectedShot:{title:"",description:"",explanationAssetId:"",imageAssetId:""},
      scriptDetail:{},
      alertOpen:false,
      alertText:"",
      zipUploadOpen:false,
      shotUpdateOpen:false,
      zipUploadProcessingOpen:false,
      zipUploadFailureOpen:false,
      storyboardWarnings:{
        title:false, description:false, coverImage:false, DGVideo:false
      }

    }
    this.uploadModalOpen = this.uploadModalOpen.bind(this);
    this.uploadModalSubmit = this.uploadModalSubmit.bind(this);
    this.toggle = this.toggle.bind(this);
    this.renderDetailsBody = this.renderDetailsBody.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.changeTitle = this.changeTitle.bind(this);
    this.releaseStoryboard =  this.releaseStoryboard.bind(this);
    this.changeShotTitle = this.changeShotTitle.bind(this);
    this.changeShotDescription = this.changeShotDescription.bind(this);
    this.changeDescription = this.changeDescription.bind(this);
    this.renderShots = this.renderShots.bind(this);
    this.uploadModalClose = this.uploadModalClose.bind(this);
    this.updateStoryboardDetail = this.updateStoryboardDetail.bind(this);
    this.shotToggle = this.shotToggle.bind(this);
    this.handleStoryboardAssetChange = this.handleStoryboardAssetChange.bind(this);
    this.uploadShotAsset = this.uploadShotAsset.bind(this);
    this.closeZipAlert = this.closeZipAlert.bind(this);
    this.closeZipUploadProcessing = this.closeZipUploadProcessing.bind(this);
    this.closeAlert = this.closeAlert.bind(this);
    this.closeFailureZipAlert = this.closeFailureZipAlert.bind(this);
    this.storyboardValidation = this.storyboardValidation.bind(this);
    this.storyboardWarningsTitleJudge = this.storyboardWarningsTitleJudge.bind(this);
    this.storyboardWarningsDescriptionJudge = this.storyboardWarningsDescriptionJudge.bind(this);
    this.storyboardWarningsCoverImageJudge = this.storyboardWarningsCoverImageJudge.bind(this);
    this.toggleUGVShot = this.toggleUGVShot.bind(this);
    this.storyboardWarningsExplanationVideoJudge = this.storyboardWarningsExplanationVideoJudge.bind(this);
    this.changeShotNumber = this.changeShotNumber.bind(this);
    this.calculateUGVs = this.calculateUGVs.bind(this);
    this.handleShotAssetChange = this.handleShotAssetChange.bind(this);
    this.closeReleaseFailure = this.closeReleaseFailure.bind(this);

  }

  calculateUGVs() {
    let count = 0;
    this.state.scriptDetail.shots.map((item) => {
      if (item.isUGV) {
        count += 1;
      };
    })
    return count;
  }

  componentWillMount() {

    // We're editing an existing storyboard.
    if (this.props.match.params.Id) {

      this.setState({
        uploadModalOpen: false
      });

      let authToken = this.props.user.authToken;
      let cId = this.props.user.customerId;
      let sId = parseInt(this.props.match.params.Id);

      $.ajax({
        url: `https://screen.mobflic.com/v1/customers/${cId}/storyboards/${sId}`,
        type: 'GET',
        beforeSend: function (xhr) {
          xhr.setRequestHeader("X-Auth-Token", authToken);
        },
        success: (res) => {
          const scriptDetail = res.result;
          scriptDetail.shots = this.assembleShots(scriptDetail);
          this.setState({
            scriptDetail: scriptDetail
          },() => { this.setState({contentStatus:true},() => {this.forceUpdate()})});
        }
      });
    }
  }

  assembleShots(script) {
    const baseShots = script.shots;
    const shotIds = baseShots.map(shot => shot.id);
    const assets = script.assets.filter(asset => !shotIds.includes(asset.shotId));

    const oldShots = baseShots.map(baseShot => {
      return Object.assign({}, baseShot, {
        isUGV: true,
        baseAssetId: script.assets.filter(asset => asset.shotId === baseShot.id)[0].id,
        newShotNumber: baseShot.shotNumber
      });
    });

    const newShots = assets.map((asset, index) => {

      const extension = asset.originalFileName?asset.originalFileName.toLowerCase().substr((asset.originalFileName.lastIndexOf('.') + 1)):"";
      const isNotVideo = extension?["wav" , "mp3", "jpg", "png"].includes(extension):false;

      return {
        baseAssetId: asset.id,
        isUGV: false,
        description: "",
        explanationAssetId: "",
        imageAssetId: "",
        shotNumber: oldShots.length + index + 1,
        newShotNumber: oldShots.length + index + 1,
        durationMillis: asset.durationMillis,
        originalFileName: asset.originalFileName,
        title: asset.title,
        scriptToken: asset.scriptToken,
        isNotVideo: isNotVideo
      };
    });

    return oldShots.concat(newShots);
  }

  storyboardValidation() {
    if (this.state.contentStatus) {
    if(this.state.scriptDetail.title.length===0){
      let newStoryboardWarnings = this.state.storyboardWarnings;
      newStoryboardWarnings.title = true;
      this.setState({
        storyboardWarnings:newStoryboardWarnings
      })

    } else {
      let newStoryboardWarnings = this.state.storyboardWarnings;
      newStoryboardWarnings.title = false;
      this.setState({
        storyboardWarnings:newStoryboardWarnings
      })
    }



    if(this.state.scriptDetail.description.length===0){
      let newStoryboardWarnings = this.state.storyboardWarnings;
      newStoryboardWarnings.description = true;
      this.setState({
        storyboardWarnings:newStoryboardWarnings
      })

    } else {
      let newStoryboardWarnings = this.state.storyboardWarnings;
      newStoryboardWarnings.description = false;
      this.setState({
        storyboardWarnings:newStoryboardWarnings
      })

    }


    if(this.state.scriptDetail.explanationAssetId.length===0){
      let newStoryboardWarnings = this.state.storyboardWarnings;
      newStoryboardWarnings.DGVideo = true;
      this.setState({
        storyboardWarnings:newStoryboardWarnings
      })

    } else {
      let newStoryboardWarnings = this.state.storyboardWarnings;
      newStoryboardWarnings.DGVideo = false;
      this.setState({
        storyboardWarnings:newStoryboardWarnings
      })

    }



    if(this.state.scriptDetail.landScapeImageAssetId.length===0){
      let newStoryboardWarnings = this.state.storyboardWarnings;
      newStoryboardWarnings.coverImage = true;
      this.setState({
        storyboardWarnings:newStoryboardWarnings
      })

    } else {
      let newStoryboardWarnings = this.state.storyboardWarnings;
      newStoryboardWarnings.coverImage = false;
      this.setState({
        storyboardWarnings:newStoryboardWarnings
      })

    }
  }


  }


  handleShotAssetChange(e) {

     this.setState({
        shotAssetFile:e.target.files[0]
      })


  }

  toggleUGVShot(item) {

    let newShots = this.state.scriptDetail.shots.slice();
    let sId =  this.state.scriptDetail.id;
    let cId = this.props.user.customerId;
    let shotId = item.id;
    let authToken = this.props.user.authToken;
    newShots.map((shotItem) => {
      if(shotItem.baseAssetId === item.baseAssetId) {
        shotItem.isUGV = !shotItem.isUGV
        if(!shotItem.isUGV) {

          $.ajax({
          url: `https://screen.mobflic.com/v1/customers/${cId}/storyboards/${sId}/shots/${shotId}`,
          type: 'delete',
          beforeSend: function (xhr) {
                  xhr.setRequestHeader ("X-Auth-Token",authToken);
          },
          success: (res,a,b) => {
            console.log("Delete Success");
          },
          error: (res,a,b) => {
              console.log("Delete Not Success");
          }
        });

        } else {
           let data = {
              assetId:shotItem.baseAssetId,
              title:shotItem.title,
              description:shotItem.description,
              shotNumber:shotItem.shotNumber
            };
            let jsonData = JSON.stringify(data);
            $.ajax({
            url: `https://screen.mobflic.com/v1/customers/${cId}/storyboards/${sId}/shots`,
            type: 'POST',
            beforeSend: function (xhr) {
                  xhr.setRequestHeader ("X-Auth-Token",authToken);
            },
            contentType:"application/json",
            data:jsonData,
            success: (res) => {
             shotItem.id = res.result.id;
             shotItem.newShotNumber = shotItem.shotNumber;
            },
            error: (res) => {
              console.log("Unsuccessful not create a shot");
            }
          })
        }
      }
    })

    let newScriptDetail = this.state.scriptDetail;
    newScriptDetail.shots = newShots;
    this.setState({scriptDetail:newScriptDetail})
    console.log(this.state.scriptDetail);
  }

  closeZipUploadProcessing() {
    this.setState({
      zipUploadProcessingOpen:false
    })
  }

  closeReleaseFailure() {
    this.setState({releaseFailureOpen:false})
  }
  closeAlert() {
    this.setState({
      alertOpen:false,
      alertText:""
    })
  }

  closeZipAlert() {
    this.setState({
      zipUploadOpen:false,
    })
  }

  closeFailureZipAlert() {
    this.setState({
      zipUploadFailureOpen:false,
      uploadModalOpen:true
    })
  }
  componentWillUpdate() {


  }

  releaseStoryboard(preferHires) {
    let sId =  this.state.scriptDetail.id;
    let cId = this.props.user.customerId;
    let authToken = this.props.user.authToken;

    let data = {
      hires:preferHires
     };
     let jsonData = JSON.stringify(data);

     $.ajax({
          url: `https://screen.mobflic.com/v1/customers/${cId}/storyboards/${sId}/release`,
          type: 'POST',
          data: jsonData,
          beforeSend: function (xhr) {
                  xhr.setRequestHeader ("X-Auth-Token",authToken);
          },
          success: (res,a,b) => {
            this.setState({
              path:"YourStoryboards",
              navigate:true
            })
         },
        error: (res,a,b) => {
            console.log(res);
            this.setState({releaseFailureOpen:true})
            this.setState({msg: res.messages})
        }
      });
  }



  uploadStoryboardAsset() {

    let cId = this.props.user.customerId;
    let authToken = this.props.user.authToken;

    this.setState({assetProcessingOpen:true})

    $.ajax({
          url: `https://screen.mobflic.com/v1/customers/${cId}/assets`,
          type: 'POST',
          beforeSend: function (xhr) {
                  xhr.setRequestHeader ("X-Auth-Token",authToken);
          },
          processData:false,
          data: this.state.storyboardAssetFile,
          success: (res,a,b) => {
            this.setState({assetProcessingOpen:false})

            if(this.state.activeTab === '1')
            {
              let newScriptDetail = this.state.scriptDetail;


              newScriptDetail.explanationAssetId = res.result.assetId;
              this.setState({scriptDetail:newScriptDetail},() => {

                  console.log(res);
              let newScriptSummary = {
              id:this.state.scriptDetail.id,
              title:this.state.scriptDetail.title,
              description:this.state.scriptDetail.description,
              numberOfShots:this.state.scriptDetail.shots.length,
              explanationAssetId:this.state.scriptDetail.explanationAssetId,
              landScapeImageAssetId:this.state.scriptDetail.landScapeImageAssetId,
              projectId:this.state.scriptDetail.projectId


            };
            let cId = this.props.user.customerId;
            let sId = this.state.scriptDetail.id;
            let jsonData = JSON.stringify(newScriptSummary);
            let authToken = this.props.user.authToken;

            $.ajax({
                  url: `https://screen.mobflic.com/v1/customers/${cId}/storyboards/${sId}`,
                  type: 'POST',
                  beforeSend: function (xhr) {
                          xhr.setRequestHeader ("X-Auth-Token",authToken);
                  },
                  contentType:"application/json",
                  data: jsonData,
                  success: (res) => {
                    let Id = this.state.scriptDetail.id;
                    let newDetail = this.state.scriptDetail;
                    newDetail.id = Id;
                    this.setState({
                      scriptDetail:newDetail
                    })
                  },
                  error: (res,a,b) => {
                      console.log(res);
                  }


              });

              });
              this.setState({alertOpen:true,alertText:"You have Successfully uploaded an asset"});
            } else {

              let newScriptDetail = this.state.scriptDetail;
              let aId = res.result.assetId;
              newScriptDetail.landScapeImageAssetId = res.result.assetId;

              let newScriptSummary = {
              id:this.state.scriptDetail.id,
              title:this.state.scriptDetail.title,
              description:this.state.scriptDetail.description,
              numberOfShots:this.state.scriptDetail.shots.length,
              explanationAssetId:this.state.scriptDetail.explanationAssetId,
              landScapeImageAssetId:aId,
              projectId:this.state.scriptDetail.projectId


            };
            let cId = this.props.user.customerId;
            let sId = this.state.scriptDetail.id;
            let jsonData = JSON.stringify(newScriptSummary);
            let authToken = this.props.user.authToken;

            $.ajax({
                  url: `https://screen.mobflic.com/v1/customers/${cId}/storyboards/${sId}`,
                  type: 'POST',
                  beforeSend: function (xhr) {
                          xhr.setRequestHeader ("X-Auth-Token",authToken);
                  },
                  contentType:"application/json",
                  data: jsonData,
                  success: (res) => {

                    let url = aId?"https://screen.mobflic.com/v1/customers/"+  this.props.user.customerId+ "/assets/" + encodeURIComponent(aId) + "?storyboardId=" + this.state.scriptDetail.id + "&authToken=" + this.props.user.authToken:"";

                    let newDetail = this.state.scriptDetail;
                    newDetail.landScapeImageAssetId = aId;
                    console.log(aId);
                    this.setState({
                      coverUrl:url,
                      scriptDetail:newDetail
                    })
                    this.setState();
                  },
                  error: (res,a,b) => {
                      console.log(res);
                  }


              });
              this.setState({alertOpen:true,alertText:"You have Successfully uploaded an asset"});

            }
            console.log(this.state.scriptDetail);
         },
        error: (res,a,b) => {
          this.setState({assetProcessingOpen:false})
            console.log(res);
        }


      });

  }

   uploadShotAsset() {

    let cId = this.props.user.customerId;
    let authToken = this.props.user.authToken;
    this.setState({assetProcessingOpen:true})


    $.ajax({
          url: `https://screen.mobflic.com/v1/customers/${cId}/assets`,
          type: 'POST',
          beforeSend: function (xhr) {
                  xhr.setRequestHeader ("X-Auth-Token",authToken);
          },
          processData:false,
          data: this.state.shotAssetFile,
          success: (res) => {
            this.setState({assetProcessingOpen:false})
            if(this.state.shotActiveTab === '1')
            {
              let newSelectedShot = this.state.selectedShot;
              newSelectedShot.explanationAssetId = res.result.assetId;
              this.setState({selectedShot:newSelectedShot},() => {
                let sId = this.state.scriptDetail.id;
                let shotId = this.state.selectedShot.id;
                let cId = this.props.user.customerId;
                let authToken = this.props.user.authToken;
                let newShot = this.state.selectedShot;
                newShot.shotNumber = parseInt(newShot.shotNumber);
                this.setState({selectedShot:newShot},() => {
                  let jsonData = JSON.stringify(this.state.selectedShot);


                  if(this.state.selectedShot.isUGV) {

                 $.ajax({
                      url: `https://screen.mobflic.com/v1/customers/${cId}/storyboards/${sId}/shots/${shotId}`,
                      type: 'POST',
                      beforeSend: function (xhr) {
                              xhr.setRequestHeader ("X-Auth-Token",authToken);
                     },
                      contentType:"application/json",
                      data: jsonData,
                      success: (res) => {
                          $.ajax({
                        url: `https://screen.mobflic.com/v1/customers/${cId}/storyboards/${sId}`,
                        type: 'GET',
                        beforeSend: function (xhr) {
                                xhr.setRequestHeader ("X-Auth-Token",authToken);
                       },
                        contentType:"application/json",
                        success: (res) => {
                          let newShots = this.state.scriptDetail.shots.slice();
                          console.log(newShots);
                          console.log(res.result.shots);
                          res.result.shots.map((item) => {
                            for (var i = 0;i < newShots.length;i++){

                              if(newShots[i].id == item.id) {
                                newShots[i].shotNumber = item.shotNumber;

                              }

                            }
                          })
                          let newScript = this.state.scriptDetail;
                          newScript.shots = newShots;
                          this.setState({
                            scriptDetail:newScript,
                          })
                      },
                        error: (res,a,b) => {
                            console.log(res);
                        }
                     });
                    },
                    error: (res,a,b) => {
                        console.log(res);
                    }
                   });


                  }
                })

              });
              this.setState({alertOpen:true, alertText:"You have Successfully uploaded an asset"});
            } else {

              let newSelectedShot = this.state.selectedShot;
              newSelectedShot.imageAssetId = res.result.assetId;
              this.setState({selectedShot:newSelectedShot},() => {
              let sId = this.state.scriptDetail.id;
                let shotId = this.state.selectedShot.id;
                let cId = this.props.user.customerId;
                let authToken = this.props.user.authToken;
                let newShot = this.state.selectedShot;
                newShot.shotNumber = parseInt(newShot.shotNumber);
                this.setState({selectedShot:newShot},() => {
                  let jsonData = JSON.stringify(this.state.selectedShot);

                  if(this.state.selectedShot.isUGV) {

                 $.ajax({
                      url: `https://screen.mobflic.com/v1/customers/${cId}/storyboards/${sId}/shots/${shotId}`,
                      type: 'POST',
                      beforeSend: function (xhr) {
                              xhr.setRequestHeader ("X-Auth-Token",authToken);
                     },
                      contentType:"application/json",
                      data: jsonData,
                      success: (res) => {
                          $.ajax({
                        url: `https://screen.mobflic.com/v1/customers/${cId}/storyboards/${sId}`,
                        type: 'GET',
                        beforeSend: function (xhr) {
                                xhr.setRequestHeader ("X-Auth-Token",authToken);
                       },
                        contentType:"application/json",
                        success: (res) => {
                          let url = this.state.selectedShot.imageAssetId?"https://screen.mobflic.com/v1/customers/"+  this.props.user.customerId+ "/assets/" + encodeURIComponent(this.state.selectedShot.imageAssetId) + "?storyboardId=" + this.state.scriptDetail.id + "&authToken=" + this.props.user.authToken:"";
                          this.setState({
                            shotCoverAddress:url
                          })
                         let newShots = this.state.scriptDetail.shots.slice();
                          console.log(newShots);
                          console.log(res.result.shots);
                          res.result.shots.map((item) => {
                            for (var i = 0;i < newShots.length;i++){

                              if(newShots[i].id == item.id) {
                                newShots[i].shotNumber = item.shotNumber;
                                console.log("match!");
                              }

                            }
                          })
                          let newScript = this.state.scriptDetail;
                          newScript.shots = newShots;
                          this.setState({
                            scriptDetail:newScript,
                          })
                      },
                        error: (res,a,b) => {
                            console.log(res);
                        }
                     });
                    },
                    error: (res,a,b) => {
                        console.log(res);
                    }
                   });


                  }
                })
              });
              this.setState({alertOpen:true, alertText:"You have Successfully uploaded an asset"});

            }
            console.log(this.state.scriptDetail);
         },
        error: (res,a,b) => {
           this.setState({assetProcessingOpen:false})
            console.log(res);
        }


      });

  }


  updateStoryboardDetail() {
    let cId = this.props.user.customerId;
    let sId = this.state.scriptDetail.id;
    let authToken = this.props.user.authToken;
    let self = this; // Make life easier in the deferred.

    let newScriptSummary = {
      id:this.state.scriptDetail.id,
      title:this.state.scriptDetail.title,
      description:this.state.scriptDetail.description,
      numberOfShots:this.state.scriptDetail.shots.length,
      explanationAssetId:this.state.scriptDetail.explanationAssetId,
      landScapeImageAssetId:this.state.scriptDetail.landScapeImageAssetId,
      projectId:this.state.scriptDetail.projectId
    };

    let ugvShots = this.state.scriptDetail.shots.sort(function(a, b){return a.newShotNumber - b.newShotNumber}).filter(shot => shot.id && shot.isUGV);

    // Since we don't do drag/drop we need to make the shotNumbers permenant in the correct order
    // Must update the shots from final order to avoid side-effects of re-ordering on server.
    let index = 0;
    var deferred = $.Deferred();

    $.when.apply($, ugvShots.map(function(shot) {
      index += 1;

      if (shot.shotNumber != shot.newShotNumber) {
        shot.shotNumber = index;
        shot.newShotNumber = index;

        console.log("Updating shot " + shot.title);

        let jsonData = JSON.stringify(shot);
        return $.ajax({
             url: `https://screen.mobflic.com/v1/customers/${cId}/storyboards/${sId}/shots/${shot.id}`,
             type: 'POST',
             beforeSend: function (xhr) {
                     xhr.setRequestHeader ("X-Auth-Token",authToken);
            },
             contentType:"application/json",
             data: jsonData
         })
      }
      else {
          return $.Deferred(function() { console.log("Skipping shot " + shot.title)});
      }
    })).done(function() {
      deferred.resolve(arguments);
    })

    deferred.then(function(arg) {
      console.log("Updating Storyboard meta data " + sId);

      let jsonData = JSON.stringify(newScriptSummary);

      return $.ajax({
            url: `https://screen.mobflic.com/v1/customers/${cId}/storyboards/${sId}`,
            type: 'POST',
            beforeSend: function (xhr) {
                    xhr.setRequestHeader ("X-Auth-Token",authToken);
            },
            contentType:"application/json",
            data: jsonData
      })

    }).then(function(arg) {
      console.log("Getting updated Storyboard details " + sId);

      return $.ajax({
          url: `https://screen.mobflic.com/v1/customers/${cId}/storyboards/${sId}`,
          type: 'GET',
          beforeSend: function (xhr) {
                  xhr.setRequestHeader ("X-Auth-Token",authToken);
          },
          contentType:"application/json"
        })
    }).done(function(res) {
      const scriptDetail = res.result;
      console.log("Details fetched " + scriptDetail.id);

      scriptDetail.shots = self.assembleShots(scriptDetail);
      self.setState({
        scriptDetail:scriptDetail,
        alertOpen:true,
        alertText:"You have Successfully updated the storyboard."
      });

    }).fail(function(res) {
      console.log("Failed " + res);
      self.setState({alertOpen:true, alertText:"Failed to update the storyboard. Please try again shortly."});
    }).done();

    deferred.resolve();
  }

  shotToggle(tab) {
    if (this.state.shotActiveTab !== tab) {
      this.setState({
        shotActiveTab: tab
      });
    }

  }

  handleChange(event) {
      console.log('Selected file:', event.target.files[0]);
      console.log(event.target.files[0]);
      this.setState({
        file:event.target.files[0]
      })
  }

  handleStoryboardAssetChange(e) {
     this.setState({
        storyboardAssetFile:e.target.files[0]
     })
  }

  handleTitleChange(e) {
      this.setState({
        title:e.target.value
      })
    }


  changeTitle(e) {
    const newScriptDetail = this.state.scriptDetail;
    newScriptDetail.title = e.target.value;
    this.setState({scriptDetail: newScriptDetail},() => {console.log(this.state.scriptDetail);});
  }

  changeDescription(e){
    const newScriptDetail = this.state.scriptDetail;
    newScriptDetail.description = e.target.value;
    this.setState({scriptDetail: newScriptDetail},() => {console.log(this.state.scriptDetail);});


  }



  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  }

  uploadModalClose() {
    this.setState({
      uploadModalOpen:false,
      navigate:true,
      path:"YourStoryboards"
    })
  }

  storyboardWarningsTitleJudge() {
   if (this.state.storyboardWarnings.title) {
            return (
                <p style={{color:"red","fontSize":"15px"}}>* Storyboard title is Missing</p>
              )
          }
  }
  storyboardWarningsDescriptionJudge() {
   if (this.state.storyboardWarnings.title) {
            return (
                <p style={{color:"red","fontSize":"15px"}}>* Storyboard title is Missing</p>
              )
          }
  }

  storyboardWarningsExplanationVideoJudge()
   {
           if (this.state.storyboardWarnings.DGVideo) {
            return (
                <p style={{color:"red","fontSize":"15px"}}>* Storyboard Explanation Video is Missing</p>
              )
          }
        }


  editShotModalOpen(shot) {
    let url = shot.imageAssetId?"https://screen.mobflic.com/v1/customers/"+  this.props.user.customerId+ "/assets/" + encodeURIComponent(shot.imageAssetId) + "?storyboardId=" + this.state.scriptDetail.id + "&authToken=" + this.props.user.authToken:"";

    this.setState({
      editShotModalOpen:true,
      selectedShot:shot,
      shotCoverAddress:url

    })


  }

  changeShotTitle(e) {

    let originalShot = this.state.selectedShot;
    originalShot.title = e.target.value;
    this.setState({selectedShot: originalShot});


  }


  changeShotNumber(e) {

    let originalShot = this.state.selectedShot;
    originalShot.newShotNumber = e.target.value;
    this.setState({selectedShot: originalShot});

  }


 storyboardWarningsCoverImageJudge(){
           if (this.state.storyboardWarnings.coverImage) {
            return (
                <p style={{color:"red","fontSize":"15px"}}>* Storyboard Cover Image is Missing</p>
              )
          }
        }



  changeShotDescription(e) {

    console.log(e.target.value);
    let originalShot = this.state.selectedShot;
    originalShot.description = e.target.value;
    this.setState({selectedShot: originalShot});


  }

  renderShots() {

    if (this.state.contentStatus) {
    return (
       <Row>
              {

                  this.state.scriptDetail.shots.map((item) => {
                    return (
                                     <Col xs="4">

                                      <Card>
                                        <CardHeader>
                                          Shot #{item.newShotNumber}. { item.originalFileName }

                                        <Label style={{float:"right"}} className="switch switch-text switch-pill switch-primary">
                                        {
                                          item.isNotVideo?<Input type="checkbox" checked={item.isUGV} disabled className="switch-input" />:
                                                          <Input type="checkbox" checked={item.isUGV} onChange={() => {this.toggleUGVShot(item)}} className="switch-input" />
                                        }
                                            <span className="switch-label" data-on="On" data-off="Off"></span>
                                            <span className="switch-handle"></span>
                                          </Label>
                                          <span style={{marginRight:"10px", float:"right"}}>  UGV  </span>
                                                </CardHeader>
                                                <CardBody >
                                                  <p style={{"visibility":item.isUGV?"visible":"hidden"}}><b>{'Title:'}</b></p>
                                                  <p style={{"visibility":item.isUGV?"visible":"hidden","border":item.title.length>0?"":"1px solid red","height":"30px"}}>{item.title}</p>
                                                  <p style={{"visibility":item.isUGV?"visible":"hidden"}}><b>{'Description:'}</b></p>
                                                  <p style={{"visibility":item.isUGV?"visible":"hidden","border":item.description.length>0?"":"1px solid red","height":"70px"}}>{item.description}</p>
                                                  <p><b>{'Seconds:'}</b>{item.durationMillis} ms </p>
                                                  <p style={{"visibility":item.isUGV?"visible":"hidden"}}> <i className="fa fa-edit fa-lg mt-4"></i> <a style = {{color:"#00a0e9", cursor:"pointer"}} onClick = {() => {this.editShotModalOpen(item)}}> Edit shot content </a></p>


                                                </CardBody>
                                                <CardFooter style={{textAlign:"center"}} >  </CardFooter>
                                              </Card>
                                    </Col>



                    );
                  })

              }

            </Row>

    )}


    }



  editShotModalClose() {
    this.setState({
      editShotModalOpen:false
    })
    let sId = this.state.scriptDetail.id;
    let shotId = this.state.selectedShot.id;
    let cId = this.props.user.customerId;
    let authToken = this.props.user.authToken;
    let newShot = this.state.selectedShot;
    newShot.shotNumber = parseInt(newShot.shotNumber);
    newShot.newShotNumber = parseInt(newShot.newShotNumber);
    this.setState({selectedShot:newShot},() => {
      let jsonData = JSON.stringify(this.state.selectedShot);
      if(this.state.selectedShot.isUGV) {

     $.ajax({
          url: `https://screen.mobflic.com/v1/customers/${cId}/storyboards/${sId}/shots/${shotId}`,
          type: 'POST',
          beforeSend: function (xhr) {
                  xhr.setRequestHeader ("X-Auth-Token",authToken);
         },
          contentType:"application/json",
          data: jsonData,
          success: (res) => {
              $.ajax({
            url: `https://screen.mobflic.com/v1/customers/${cId}/storyboards/${sId}`,
            type: 'GET',
            beforeSend: function (xhr) {
                    xhr.setRequestHeader ("X-Auth-Token",authToken);
           },
            contentType:"application/json",
            success: (res) => {
              let newShots = this.state.scriptDetail.shots.slice();
              res.result.shots.map((item) => {
                for (var i = 0;i < newShots.length;i++){

                  if(newShots[i].id == item.id) {
                    newShots[i].shotNumber = item.shotNumber;
                  }
                }
              })
              let newScript = this.state.scriptDetail;
              newScript.shots = newShots;
              this.setState({
                scriptDetail:newScript
              })
          },
            error: (res,a,b) => {
                console.log(res);
            }
         });
        },
        error: (res,a,b) => {
            console.log(res);
        }
       });
      }
    })

    console.log(this.state.selectedShot);

  }

 closeShotUpdate() {
  this.setState({
    shotUpdateOpen:false
  })
}

  uploadModalOpen() {
    this.setState({
      uploadModalOpen: true
    });
  }

  uploadModalSubmit() {

     let authToken = this.props.user.authToken;
     let cId = this.props.user.customerId;
     let sId = parseInt(this.props.match.params.Id);

     this.setState({zipUploadProcessingOpen: true, uploadModalOpen:false})



     $.ajax({
          url: `https://screen.mobflic.com/v1/customers/${cId}/storyboards/${sId}/suspend`,
          type: 'POST',
          beforeSend: function (xhr) {
                  xhr.setRequestHeader ("X-Auth-Token",authToken);
          },
          success: (res) => {

                 $.ajax({
                url: `https://screen.mobflic.com/v1/customers/${cId}/storyboards/${sId}/version`,
                type: 'POST',
                processData:false,
                beforeSend: function (xhr) {
                        xhr.setRequestHeader ("X-Auth-Token",authToken);
                },
                data: this.state.file,
                success: (res) => {
                  this.setState({zipUploadProcessingOpen: false});

                  let newScriptDetail = {};
                  newScriptDetail = res.result.script;
                  $.ajax({
                    url: `https://screen.mobflic.com/v1/customers/${cId}/storyboards/${sId}`,
                    type: 'GET',
                    beforeSend: function (xhr) {
                        xhr.setRequestHeader ("X-Auth-Token",authToken);
                    },
                    success: (res) => {

                            for (let i=0; i < newScriptDetail.shots.length; i++) {
                        for(let j=0; j < res.result.shots.length; j++) {

                          if (res.result.shots[j].scriptToken == newScriptDetail.shots[i].scriptToken) {
                            newScriptDetail.shots[i].originalFileName = res.result.shots[j].originalFileName;
                            newScriptDetail.shots[i].isUGV = true;
                          };
                        }
                      }


                        for (let i=0; i < newScriptDetail.shots.length; i++) {
                          for (let j=0; j < newScriptDetail.assets.length; j++) {
                            if(newScriptDetail.shots[i].originalFileName == newScriptDetail.assets[i].originalFileName) {
                              newScriptDetail.shots[i].baseAssetId = newScriptDetail.assets[i].id;
                            }
                          }
                        }



                  this.setState({
                    scriptDetail:newScriptDetail
                  },() => { this.setState({contentStatus:true},() => {this.forceUpdate()})});

                  this.setState({
                    zipUploadOpen:true,
                    uploadModalOpen:false
                  });

                    },
                    error: (res) => {

                    }
                  })
            },
            error: (res,a,b) => {
              this.setState({zipUploadProcessingOpen:false,
                zipUploadFailureOpen: true})

            }


          });


         },
          error: (res) => {
          this.setState({zipUploadProcessingOpen:false,
            zipUploadFailureOpen: true})

          }
   })
}

  renderDetailsBody() {
    if(this.state.contentStatus) {

      const showSuspendButton = this.state.scriptDetail.status === "Published";
      const showEditButton = this.state.scriptDetail.status === "Draft";

      return (
       <div>
        <Row>
           <Col xs="3" >
            </Col>
            <Col xs="5" >
            </Col>
            <Col xs="2" >
            {
              showEditButton ? <Button  style={{"width":"100%","borderRadius":"5px"}} onClick={() => this.releaseStoryboard(true)}  color="success">Release(To Dev)</Button> : null
            }
            </Col>

            <Col xs="2" >
             <Button  style={{"width":"100%","borderRadius":"5px"}} onClick={() => this.updateStoryboardDetail()}  color="success">Save</Button>
            </Col>
        </Row>


        <Row style={{marginTop:"20px"}}>
          <Col xs="6" >
            <Card>
              <CardHeader>
               <strong> Storyboards Details </strong>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col>
                    <FormGroup row>
                      <Col xs="12" >
                        <Label htmlFor="text-input">Title</Label>
                      </Col>
                      <Col xs="12" >
                        <Input style={{"border":this.state.scriptDetail.title.length>0?"":"1px solid red"}} type="text" id="text-input" value={this.state.scriptDetail.title} onChange={this.changeTitle} name="text-input" placeholder="Text" />
                        <FormText style={{"visibility":this.state.scriptDetail.title.length>0?"hidden":"visible"}} className="help-block"><span style={{"color":"red"}}>Please enter storyboard title</span></FormText>
                      </Col>
                    </FormGroup>
                  </Col>
                </Row>

                 <Row>
                  <Col>
                    <FormGroup row>
                      <Col xs="12" >
                        <Label htmlFor="text-input">Description</Label>
                      </Col>
                      <Col xs="12">
                        <Input style={{"border":this.state.scriptDetail.description.length>0?"":"1px solid red"}} type="textarea" name="textarea-input" value={this.state.scriptDetail.description} onChange={this.changeDescription} id="textarea-input" rows="5"
                               placeholder="Content..."/>
                        <FormText style={{"color":"red","visibility":this.state.scriptDetail.description.length>0?"hidden":"visible"}} className="help-block"><span style={{"color":"red"}}>Please enter storyboard description</span></FormText>
                      </Col>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <FormGroup row>
                      <Col xs="12" >
                        <h2 > <Label>Status</Label> </h2>
                      </Col>
                      <Col xs="12">
                        <p>
                         { this.state.scriptDetail.status }
                        </p>
                      </Col>
                    </FormGroup>
                  </Col>
                </Row>

              </CardBody>
            </Card>

          </Col>

          <Col xs="6" >
            <Card>
              <CardHeader>
               <strong> Storyboards Assets </strong>
              </CardHeader>
              <CardBody>
            <Col xs="12" className="mb-4">
            <Nav tabs>
              <NavItem>
                <NavLink
                  className={classnames({ active: this.state.activeTab === '1' })}
                  onClick={() => { this.toggle('1'); }}
                >
                 Video
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: this.state.activeTab === '2' })}
                  onClick={() => { this.toggle('2'); }}
                >
                  Cover Image
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent activeTab={this.state.activeTab}>
              <TabPane style={{"border":this.state.scriptDetail.explanationAssetId && this.state.scriptDetail.explanationAssetId.length>0?"":"1px solid red",height:"222px",width:"95%"}} tabId="1">
              {
                (typeof this.state.scriptDetail.explanationAssetId !== 'undefined') &&  this.state.scriptDetail.explanationAssetId && this.state.scriptDetail.explanationAssetId.length > 0?
                   (this.state.scriptDetail.explanationAssetId.substr(this.state.scriptDetail.explanationAssetId.length-1,1)=="8"?
                     <ReactHLS style={{"marginLeft":"2%", "height":"222px", "width":"auto"}} videoProps={{"height":"222","width":"auto"}} url={"https://screen.mobflic.com/v1/customers/"+  this.props.user.customerId+ "/assets/" + encodeURIComponent(this.state.scriptDetail.explanationAssetId) + "?storyboardId=" + this.state.scriptDetail.id + "&authToken=" + this.props.user.authToken}/>:
                     <video style={{"marginLeft":"2%", "height":"222px","width":"auto"}} width="auto" height="222" controls src={"https://screen.mobflic.com/v1/customers/"+  this.props.user.customerId+ "/assets/" + encodeURIComponent(this.state.scriptDetail.explanationAssetId) + "?storyboardId=" + this.state.scriptDetail.id + "&authToken=" + this.props.user.authToken}></video>
                   ): null
              }

              </TabPane>
              <TabPane style={{"border":this.state.scriptDetail.landScapeImageAssetId && this.state.scriptDetail.landScapeImageAssetId.length>0?"":"1px solid red",height:"222px",width:"95%"}}  tabId="2">
              {
                this.state.coverUrl?
                  <img style={{"height":"100%","display":this.state.scriptDetail.landScapeImageAssetId && this.state.scriptDetail.landScapeImageAssetId.length>0?"":"none"}} src={this.state.coverUrl} />
               :null
              }
              </TabPane>
            </TabContent>
            </Col>
              </CardBody>

            <CardFooter  > <Input style={{display:"block",float:"right"}} onChange={this.handleStoryboardAssetChange}  type="file" id="file-input" name="file-input"/>
                         <Button style={{"borderRadius":"5px"}} onClick={() => this.uploadStoryboardAsset()} color="primary">Upload file</Button>
                     </CardFooter>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col xs="6">
            <Widget04 icon="icon-frame" style={{backgroundColor:"#63C2E4", color:"#ffffff"}} header={this.state.scriptDetail.assets.length.toString()}>SHOTS</Widget04>
          </Col>
          <Col xs="6">
            <Widget04 icon="icon-camrecorder" style={{backgroundColor:"#82D19D", color:"#ffffff"}} header={this.calculateUGVs().toString()}>USER GENERATED SHOTS</Widget04>
          </Col>
        </Row>




                 <Modal size="lg" style={{"width":"1000px"}} isOpen={this.state.editShotModalOpen}>
                  <ModalHeader >{ this.state.selectedShot.originalFileName }</ModalHeader>
                  <ModalBody>
                    <Row>
                      <Col xs="5">
                       <Row>
                        <Col>
                          <FormGroup row>
                            <Col xs="12" >
                              <Label htmlFor="text-input">Title</Label>
                            </Col>
                            <Col xs="12" >
                              <Input type="text" style={{"border":this.state.selectedShot.title.length>0?"":"1px solid red","height":"30px"}} value={this.state.selectedShot.title} onChange={this.changeShotTitle} id="text-input" name="text-input" placeholder="Text"/>
                              <FormText style={{"color":"red","visibility":this.state.selectedShot.title.length>0?"hidden":"visible"}} className="help-block"><span style={{"color":"red"}}>Please enter shot title</span></FormText>

                            </Col>
                          </FormGroup>
                        </Col>
                      </Row>

                       <Row>
                        <Col>
                          <FormGroup row>
                            <Col xs="12" >
                              <Label htmlFor="text-input">Shot instructions</Label>
                            </Col>
                            <Col xs="12" >
                              <Input type="textarea" rows="5" style={{"border":this.state.selectedShot.description.length>0?"":"1px solid red"}} value={this.state.selectedShot.description} onChange={this.changeShotDescription} placeholder="Text"/>
                              <FormText style={{"color":"red","visibility":this.state.selectedShot.description.length>0?"hidden":"visible"}} className="help-block"><span style={{"color":"red"}}>Please enter shot description</span></FormText>

                            </Col>
                          </FormGroup>
                        </Col>
                      </Row>


                       <Row>
                        <Col>
                          <FormGroup row>
                            <Col xs="12" >
                              <Label htmlFor="text-input">Shot Number</Label>
                            </Col>
                            <Col xs="12" >
                              <Input type="number" min="1" style={{"height":"30px"}} value={this.state.selectedShot.newShotNumber} onChange={this.changeShotNumber} id="text-input" name="text-input" placeholder="shotNumber"/>

                            </Col>
                          </FormGroup>
                        </Col>
                      </Row>


                       <Row>
                        <Col>
                        shot length
                        </Col>
                      </Row>

                      <Row style={{"fontSize":"24px"}}>
                        <Col>
                          {this.state.selectedShot.durationMillis} ms
                        </Col>
                      </Row>

                      </Col>
                      <Col xs="7">
                       <Card>
                          <CardHeader>
                           <strong> Shots Assets </strong> <Button style={{"borderRadius":"5px",float:"right"}} onClick={() => this.uploadShotAsset()} color="primary">Upload file</Button>
                          </CardHeader>
                          <CardBody>
                        <Col xs="12" className="mb-4">
                        <Nav tabs>
                          <NavItem>
                            <NavLink
                              className={classnames({ active: this.state.shotActiveTab === '1' })}
                              onClick={() => { this.shotToggle('1'); }}
                            >
                             Video
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              className={classnames({ active: this.state.shotActiveTab === '2' })}
                              onClick={() => { this.shotToggle('2'); }}
                            >
                              Cover Image
                            </NavLink>
                          </NavItem>
                        </Nav>
                        <TabContent activeTab={this.state.shotActiveTab}>
                          <TabPane style={{"border":this.state.selectedShot.explanationAssetId && this.state.selectedShot.explanationAssetId.length>0?"":"1px solid red", height:"222px",width:"100%"}} tabId="1">
                          {
                            (typeof this.state.selectedShot.explanationAssetId !== 'undefined') &&  this.state.selectedShot.explanationAssetId && this.state.selectedShot.explanationAssetId.length > 0?
                               (this.state.selectedShot.explanationAssetId.substr(this.state.selectedShot.explanationAssetId.length-1,1)=="8"?
                                 <ReactHLS style={{"marginLeft":"2%", "height":"190px", "width":"auto"}} videoProps={{"height":"190","width":"auto"}} url={"https://screen.mobflic.com/v1/customers/"+  this.props.user.customerId+ "/assets/" + encodeURIComponent(this.state.selectedShot.explanationAssetId) + "?storyboardId=" + this.state.scriptDetail.id + "&authToken=" + this.props.user.authToken}/>:
                                 <video style={{"marginLeft":"2%", "height":"222px", "width":"auto"}}  width="auto" height="222" controls src={"https://screen.mobflic.com/v1/customers/"+  this.props.user.customerId+ "/assets/" + encodeURIComponent(this.state.selectedShot.explanationAssetId) + "?storyboardId=" + this.state.scriptDetail.id + "&authToken=" + this.props.user.authToken}></video>
                               ): null
                          }
                        </TabPane>

                          <TabPane style={{"border":this.state.selectedShot.imageAssetId && this.state.selectedShot.imageAssetId.length>0?"":"1px solid red", height:"222px",width:"100%"}}  tabId="2">
                          {
                            this.state.shotCoverAddress?
                             <img style={{"height":"100%","display":this.state.selectedShot.imageAssetId && this.state.selectedShot.imageAssetId.length>0?"":"none"}} src={this.state.shotCoverAddress} />
                             :null
                           }
                          </TabPane>

                        </TabContent>
                        </Col>
                          </CardBody>

                        <CardFooter >

                          <Input style={{float:"right",width:"180px"}} onChange={this.handleShotAssetChange} type="file" id="file-input" name="file-input"/>

                       </CardFooter>
                        </Card>
                      </Col>
                    </Row>
                  </ModalBody>
                  <ModalFooter>
                    <Button color="secondary" onClick={() => this.setState({editShotModalOpen:false})} >Cancel</Button>
                    <Button color="secondary" onClick={() => this.editShotModalClose()} >Save</Button>
                  </ModalFooter>
                </Modal>

                </div>
      )
    }
    else {
      return;
    }
  }


  render() {

    const { navigate, path } = this.state

    // here is the important part
    if (navigate) {
      console.log(path);
      return <Redirect to={ "/" + path } push={true} />
    }

    return (


      <div className="animated fadeIn">
      <img ref="img" />
      <canvas style={{"display":"none"}} ref="canvas" width={300} height={300}/>
             {this.renderDetailsBody()}

             {

                this.renderShots()
             }

             <Modal  isOpen={this.state.uploadModalOpen}>
                  <ModalHeader>Upload a storyboard</ModalHeader>
                  <ModalBody>
                    Upload your storyboard files and assets to your portal
                    <Row style={{marginTop:"50px",padding:"20px 30px"}}>
                      <Col xs="8">
                      <Input type="file" onChange={this.handleChange} id="file-input" name="file-input"/>
                      </Col>
                    </Row>
                  </ModalBody>
                  <ModalFooter>
                    <Button color="secondary" onClick={() => this.uploadModalSubmit()} >Submit</Button>
                    <Button color="secondary" onClick={() => this.uploadModalClose()} >Cancel</Button>
                  </ModalFooter>
                </Modal>

              <Modal isOpen={this.state.alertOpen}
                       className={'modal-success'}>
                  <ModalHeader >Update Successful</ModalHeader>
                  <ModalBody>
                   {this.state.alertText}
                  </ModalBody>
                  <ModalFooter>
                    <Button color="secondary" onClick={() => {this.closeAlert()}}>Ok</Button>
                  </ModalFooter>
                </Modal>


                <Modal isOpen={this.state.zipUploadOpen}
                       className={'modal-success'}>
                  <ModalHeader >Storyboard Upload Successful</ModalHeader>
                  <ModalBody>
                   Storyboard Bundle Upload Successful.
                  </ModalBody>
                  <ModalFooter>
                    <Button color="secondary" onClick={() => {this.closeZipAlert()}}>Ok</Button>
                  </ModalFooter>
                </Modal>


                <Modal isOpen={this.state.shotUpdateOpen}
                       className={'modal-success'}>
                  <ModalHeader >Shot updated Successful</ModalHeader>
                  <ModalBody>
                   Storyboard Bundle Upload Successful.
                  </ModalBody>
                  <ModalFooter>
                    <Button color="secondary" onClick={() => {this.closeShotUpdate()}}>Ok</Button>
                  </ModalFooter>
                </Modal>



                 <Modal isOpen={this.state.shotUpdateOpen}
                       className={'modal-success'}>
                  <ModalHeader >Shot updated Successful</ModalHeader>
                  <ModalBody>
                   Storyboard Bundle Upload Successful.
                  </ModalBody>
                  <ModalFooter>
                    <Button color="secondary" onClick={() => {this.closeShotUpdate()}}>Ok</Button>
                  </ModalFooter>
                </Modal>


                 <Modal isOpen={this.state.assetProcessingOpen}
                       className={'modal-info'}>
                  <ModalHeader >Asset Uploading</ModalHeader>
                  <ModalBody>
                     Uploading the asset, please wait a moment
                  </ModalBody>
                  <ModalFooter>
                  </ModalFooter>
                </Modal>


                <Modal isOpen={this.state.releaseFailureOpen}
                       className={'modal-danger'}>
                  <ModalHeader >Failed to release the Storyboard</ModalHeader>
                  <ModalBody>
                    The storyboard is failed because the Storyboard coverImage is missing or the coverImage of one shot is missing.


                  </ModalBody>
                  <ModalFooter>

                  <Button color="secondary" onClick={() => {this.closeReleaseFailure()}}>Ok</Button>
                  </ModalFooter>
                </Modal>


                <Modal isOpen={this.state.zipUploadFailureOpen}
                       className={'modal-danger'}>
                  <ModalHeader >Upload is unsuccessful</ModalHeader>
                  <ModalBody>
                   The request timed out or server could not process the bundle. Please check your internet connection and make sure the bundle is of the right format(make sure you choose a file).
                  </ModalBody>
                  <ModalFooter>

                  <Button color="secondary" onClick={() => {this.closeFailureZipAlert()}}>Reupload</Button>
                  </ModalFooter>
                </Modal>

                <Modal isOpen={this.state.zipUploadProcessingOpen}
                       className={'modal-info'}>
                  <ModalHeader >Bundle Uploading</ModalHeader>
                  <ModalBody>
                  The server is processing the bundle, please wait a moment.

                  </ModalBody>
                  <ModalFooter>


                  </ModalFooter>
                </Modal>




      </div>
    )
  }
}


function mapStateToProps(state) {
    return {
        user: state.activeUser,
    };
}

export default connect(mapStateToProps)(StoryboardDetailsPage);



// WEBPACK FOOTER //
// ./src/views/Components/StoryboardEdit/StoryboardEdit.js